import { render } from "./DuplicationPopup.vue?vue&type=template&id=7daa852f&scoped=true&ts=true"
import script from "./DuplicationPopup.vue?vue&type=script&lang=ts"
export * from "./DuplicationPopup.vue?vue&type=script&lang=ts"

import "./DuplicationPopup.vue?vue&type=style&index=0&id=7daa852f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daa852f"]])

export default __exports__